import * as React from 'react';
import TableEditorSidebar from './TableEditorSidebar';

class TableEditor extends React.Component {
  constructor() {
    super();
    // state
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <TableEditorSidebar />
          <div className='h-100 d-flex align-items-center'>
            <div
              className='p-2 col-example'
              style={{
                textAlign: 'center',
                marginLeft: '100px',
                marginRight: '100px',
                width: '60%',
              }}
            >
              <i className='fa-solid fa-table' size='6x' />

              <h2 style={{ fontWeight: 'bolder', fontStyle: 'italic' }}>
              TableEditor
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TableEditor;
